import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./i18n";
import { ThemeProvider } from "styled-components/macro";
import GlobalStyle from "./styles/global";
import { theme } from "./styles/theme";
import { LoaderCustom } from "components/Loader";
import { createRoot } from 'react-dom/client';

const container = document.getElementById("root")
const root = createRoot(container!)

root.render(
  <React.StrictMode>
    <Suspense
      fallback={<LoaderCustom size={5} color={theme.colors.bgBody} text="" />}
    >
      <ThemeProvider theme={theme}>
        <App />
      </ThemeProvider>
    </Suspense>
    <GlobalStyle />
  </React.StrictMode>
);
